import React from "react";

const Footer: React.FC = () => {
  return (
    <footer className=" border-top py-3">
      <div className="container d-flex flex-wrap justify-content-between align-items-center text-center text-md-start menu-footer">
        {/* Copyright */}
        <p className="mb-2 mb-md-0 text-muted w-100 w-md-auto">
          © {new Date().getFullYear()} Piscan. All Rights Reserved.
        </p>

        {/* Links */}
        <div className="d-flex flex-wrap gap-3 align-items-center justify-content-center justify-content-md-end w-100 w-md-auto">
          <a href="/terms" className="text-primary text-decoration-none">
            Terms of Service
          </a>
          <a href="/privacy" className="text-primary text-decoration-none">
            Privacy Policy
          </a>
          <a href="/contact" className="text-primary text-decoration-none">
            Contact Us
          </a>
          <a href="/report-scam" className="text-danger fw-semibold text-decoration-none">
            Report Scam Wallet
          </a>
          <span className="d-md-inline">Follow us on X:</span>
          <a href="https://x.com/piscanofficial" target="_blank" className="text-decoration-none">
            <img src="/assets/twitterx.png" alt="X" width="40" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
